import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

console.log('Initializing i18n...');
console.log('Browser language:', navigator.language);
console.log('Browser languages:', navigator.languages);

i18n
    .use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        debug: true,
        detection: {
            order: ['navigator', 'localStorage', 'querystring', 'cookie'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng'
        },
        supportedLngs: ['en', 'sv', 'es', 'fr', 'de', 'it', 'pt', 'ru', 'ja'],
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
            requestOptions: {
                cache: 'no-store'
            }
        },
        fallbackLng: {
            default: ['en'],
            'es': ['en']
        },
        cache: {
            enabled: true
        },
        interpolation: {
            escapeValue: false,
        }
    }).then(() => {
        console.log('i18n initialized');
        console.log('Current language:', i18n.language);
        console.log('Available languages:', i18n.languages);
        console.log('Detected language from navigator:', navigator.language.split('-')[0].toLowerCase());
        
        const browserLang = navigator.language.split('-')[0].toLowerCase();
        if (i18n.languages.includes(browserLang) && browserLang !== i18n.language) {
            console.log('Language mismatch detected. Browser language available but not selected.');
            i18n.changeLanguage(browserLang);
        }
    }).catch((err: Error) => {
        console.error('Error initializing i18n:', err);
    });

export default i18n
